import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const Library = () => {
    useEffect(() => {
        document.title = 'Library -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li>  
                 <li>TAFS Library  </li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>TAFS Library </h1> 
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-6">
                            <div className="linktab"> <Link to="/SeniorLibrary"> SENIOR SCHOOL 
                            </Link> </div>
                    </div>
                    <div className="col-lg-6">
                            <div className="linktab"> <Link to="/JuniorLibrary">  JUNIOR SCHOOL
                            </Link> </div>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default Library